import { Flex } from "@chakra-ui/react";
import { colors, HStack, ColorIcon } from "goi_common";

interface StarRatingProps {
  score: number;
}

function getFixedScore(score: number) {
  return score.toFixed(1);
}

const Stars = ({ rating }: { rating: number }) => {
  return (
    <Flex paddingBottom="5px">
      {[1, 2, 3, 4, 5].map((count) => {
        return (
          <div style={{ marginRight: "1px" }} key={count}>
            <ColorIcon
              name="rating_star"
              color={rating >= count ? colors.reviewYellow : colors.gray100}
              size={18}
            />
          </div>
        );
      })}
    </Flex>
  );
};

function StarRating({ score }: StarRatingProps) {
  return (
    <HStack alignItems="center" style={{ height: "36px" }}>
      <div className="head2_b" style={{ minWidth: "32px" }}>
        {getFixedScore(score) || "-"}
      </div>
      <div style={{ marginRight: "11px" }} />
      <Stars rating={score}></Stars>
    </HStack>
  );
}

export default StarRating;
